module.exports = __webpack_public_path__ + "56815b72ded87e3b0418ba700a7ecca8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/hawaiian-beach-hut.png
// module id = 2826
// module chunks = 0